let CyesaOrderItemConfig = {
    props: {
        translations: Object,
        itemData: Object,
    },
    template: `
            <div class="d-flex flex-column flex-md-row align-items-center py-4">
                <div class="col-lg-5 mb-2 mb-md-0 py-4 py-md-0 product-image-main-info">
                    <div class="d-flex">
                        <div class="image-wrapper">
                            <img :src="itemData.imageUrl ? itemData.imageUrl : '/static/images/item-placeholder.svg'" :alt="itemData.name">
                        </div>
                        <div class="product-main-info ml-4">
                            <a v-if="itemData.productUrl" :href="itemData.productUrl" class="d-block font-weight-bold text-primary">{{ itemData.name }}</a>
                            <div v-else class="font-weight-bold text-primary">{{ itemData.name }}</div>
                            <div v-if="itemData.description2" class="my-1">{{ itemData.description2 }}</div>
                            <div class="d-flex flex-wrap item-attributes fs-12">
                                <div v-for="attr in itemData.attributes" class="mr-2">
                                    {{ attr.label }}
                                    <span class="item-attribute-value">{{ attr.value }}</span>
                                </div>
                            </div>
                            <div v-if="itemData.swrAttributes && itemData.swrAttributes.length" class="d-flex flex-column flex-wrap item-attributes rope-attributes fs-12 mt-4">
                                <div class="mr-2">
                                    <div v-for="swrAttr in itemData.swrAttributes">
                                        <span class="attribute">{{ swrAttr.label }} </span>
                                        <span class="item-attribute-value">{{ swrAttr.value }}</span>
                                    </div>
                                </div>
                            </div>
    
                            <div v-if="itemData.partCode" class="mt-1">{{ translations["orders_history.item.partcode_number_prefix"] }} {{ itemData.partCode }}</div>
                            <div v-if="itemData.comment" class="mt-4">
                                <div class="mb-2 font-weight-bold text-primary">{{ translations["orders_history.row.comment"] }}</div>
                                <div class="fs-12">{{ itemData.comment }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-lg-block col-md-2 text-md-center py-1 py-md-0">
                    <span class="mobile-label d-md-none w-50">{{ translations["orders_history.row.ot_number"] }}: </span>
                    {{ itemData.manufacturingOrder }}
                </div>
                
                <div class="d-lg-block col-md-2 text-md-center py-1 py-md-0 quantity-info">
                    <span class="mobile-label d-md-none w-50">{{ translations["orders_history.row.quantity_title"] }}: </span>
                    {{ itemData.quantity }}
                </div>

                <div class="d-lg-block col-md-3 text-md-center py-1 py-md-0 certificate">
                    <a 
                        v-if="itemData.isCertificateExists && itemData.certificateUrl"
                        :href="itemData.certificateUrl"
                        download
                        class="certificate-btn btn btn-primary my-2">
                            {{ translations["orders_history.row.certificate"] }}
                            <svg class="icon icon-chevron right"><use xlink:href="/static/icons/symbol/svg/sprite.symbol.svg#chevron"></use></svg>
                    </a>
                    <a
                        v-if="itemData.isDeclarationConformity && itemData.docUrl"
                        :href="itemData.docUrl"
                        download
                        class="doc-btn btn btn-primary my-2">
                            {{ translations["orders_history.row.doc"] }}
                            <svg class="icon icon-chevron right"><use xlink:href="/static/icons/symbol/svg/sprite.symbol.svg#chevron"></use></svg>
                    </a>
                </div>

            </div>
        `,
}

export default CyesaOrderItemConfig
